import { createStore, useStore } from 'zustand';

export interface GlobalStoreState {
  currencyId: number | undefined;
  setCurrencyId: (currencyId: number | undefined) => void;
}

export const globalStore = createStore<GlobalStoreState>((set) => ({
  currencyId: undefined,
  setCurrencyId: (currencyId) => set({ currencyId }),
}));

export const useGlobalStore = <T>(selector: (state: GlobalStoreState) => T) => {
  return useStore(globalStore, selector);
};
